export const BASE_TEN = 10;

export const ICON_SIZES = {
	small: '16px',
	medium: '24px',
	large: '32px',
	xlarge: '40px',
	xxlarge: '48px',
};
